<template>
  <div class="page">
    <div class="bg-content padding15 m-b-24">
      <el-row :gutter="24">
        <el-col :span="6">
          <el-row style="font-weight:bold;">
            <center>FS资源组</center>
          </el-row>
          <div class="padding15-tb">
            <el-row style="font-weight:bold;">
              <el-input v-model="fsName" placeholder="请输入FS资源名" clearable @clear="getBoxList(true)" @change="getBoxList(true)">
                <i slot="prefix" class="el-input__icon el-icon-search" plain @click="getBoxList(true)"></i>
              </el-input>
            </el-row>
            <el-row style="font-weight:bold;">
              <el-input v-model="supplierCompanyName" placeholder="请输入线路商名" clearable @clear="getBoxList(true)" @change="getBoxList(true)">
                <i slot="prefix" class="el-input__icon el-icon-search" plain @click="getBoxList(true)"></i>
              </el-input>
            </el-row>
          </div>
          <div style="overflow-x: hidden; overflow-y:auto;height: 80%;margin-top: 20px;">
            <el-radio-group v-model="currentBoxId" @change="boxDetail" style="height: 650px">
              <template v-for="(item) in boxList">
                <el-row :gutter="24" :key="item.boxId" style="margin-bottom: 15px;">
                  <el-col :span="24">
                    <el-radio :label="item.boxId">{{item.boxName}}</el-radio>
                  </el-col>
                </el-row>
              </template>
            </el-radio-group>
          </div>
          <div style="margin-top: 0px">
            <el-button type="success" icon="el-icon-plus" circle @click="addBoxShow"></el-button>
            <el-button type="warning" icon="el-icon-edit" circle style="margin-left: 50px;" @click="editBoxDetail"></el-button>
          </div>
        </el-col>
        <el-col :span="1">
          &nbsp;
        </el-col>
        <el-col :span="17">
          <el-tabs v-model="activeTab">
            <el-tab-pane label="FS资源" name="fs">
              <el-table :data="message[0].list" style="width: 100%">
                <el-table-column prop="fsName" label="fs服务名称" min-width="180"/>
                <el-table-column label="资源组名称" min-width="150">
                  <template slot-scope="scope">
                    <div v-if="scope.row.boxIsValid">{{scope.row.boxName}}</div>
                    <div v-if="!scope.row.boxIsValid" style="color: #909399;">--</div>
                  </template>
                </el-table-column>
                <el-table-column label="权重" min-width="150">
                  <template slot-scope="scope">
                    <el-input-number :value="scope.row.boxWeight" v-model="scope.row.boxWeight" :min=0 :max=100 :disabled="!scope.row.boxIsValid"></el-input-number>
                  </template>
                </el-table-column>
                <el-table-column label="绑定">
                  <template slot-scope="scope">
                    <el-switch
                      :value="scope.row.boxIsValid"
                      v-model="scope.row.boxIsValid"
                      active-color="#f6ac19"
                      inactive-color="#282828">
                    </el-switch>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="线路商" name="sc">
              <el-table :data="message[1].list" style="width: 100%">
                <el-table-column prop="companyName" label="线路商名称" min-width="180"/>
                <el-table-column label="资源组名称" min-width="150">
                  <template slot-scope="scope">
                    <div v-if="scope.row.boxIsValid">{{scope.row.boxName}}</div>
                    <div v-if="!scope.row.boxIsValid" style="color: #909399;">--</div>
                  </template>
                </el-table-column>
                <el-table-column label="绑定">
                  <template slot-scope="scope">
                    <el-switch
                      :value="scope.row.boxIsValid"
                      v-model="scope.row.boxIsValid"
                      active-color="#f6ac19"
                      inactive-color="#282828">
                    </el-switch>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
          </el-tabs>
        </el-col>
      </el-row>
      <el-row style="position: fixed;bottom: 20px;left: 50%;z-index: 1000;">
        <el-button type="primary" size="mini" style="margin-left: 48%; margin-top: 20px;" @click="modifyCustomerConf">提交</el-button>
      </el-row>
    </div>
    <!-- 新增 -->
    <el-dialog
      title="请添加资源组"
      :visible.sync="customerConfigure"
      width="35%"
      center>
      <div>
        <el-form size="small" label-width="130px" center>
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form-item label="资源组名称：">
                <el-input v-model="addOrUpdateBox.boxName"/>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="customerConfigure = false" size="small">取 消</el-button>
        <el-button type="primary" size="small" @click="addBox">保存</el-button>
      </div>
    </el-dialog>

    <router-view v-if="reload"></router-view>
  </div>
</template>
<script>
export default {
  data() {
    return {
      customerConfigure: false,
      activeTab: 'fs',
      message: [
        {
          'label': 'FS资源',
          'value': 'fs',
          'list': []
        }, {
          'label': '线路商',
          'value': 'sc',
          'list': []
        }
      ],
      boxId: null,
      currentBoxId: null,
      reload: false,
      fsName: '',
      supplierCompanyName: '',
      boxList: [],
      addOrUpdateBox: {
        id: null,
        boxName: null
      }
    };
  },
  methods: {
    // 资源组列表
    getBoxList(isFirstBoxId) {
      const queryUrl = `/callServer/box/boxList?fsName=${this.fsName}&supplierCompanyName=${this.supplierCompanyName}`;
      this.$ajax({
        method: 'GET',
        url: queryUrl
      }).then((res) => {
        this.boxList = res.data;
        if (this.boxList.length > 0) {
          // 是否获取第一条数据。只有更新不是获取第一条数据
          if (isFirstBoxId) {
            this.currentBoxId = this.boxList[0].boxId;
          }
          // 再展示资源组配置
          this.boxDetail(this.currentBoxId);
        } else {
          // 删除后无配置公司,置空数据
          this.currentBoxId = null;
          this.message[0].list = [];
          this.message[1].list = [];
        }
      });
    },
    // 资源组配置展示
    boxDetail(boxId) {
      this.fsDetail(boxId);
      this.scDetail(boxId);
    },
    // 资源组fs服务配置展示
    fsDetail(boxId) {
      this.message[0].list = [];
      this.$ajax({
        method: 'GET',
        url: `/callServer/box/fsDedtail/${boxId}`
      }).then((res) => {
        this.message[0].list = res.data;
      });
    },
    // 资源组供应商配置展示
    scDetail(boxId) {
      this.message[1].list = [];
      this.$ajax({
        method: 'GET',
        url: `/callServer/box/scDedtail/${boxId}`
      }).then((res) => {
        this.message[1].list = res.data;
      });
    },
    // 新增box显示
    addBoxShow() {
      this.addOrUpdateBox.id = null;
      this.addOrUpdateBox.boxName = null;
      this.customerConfigure = true;
    },
    editBoxDetail() {
      if (this.currentBoxId === null) {
        this.$confirm('未选择任何资源组, 不能修改', '提示', {
          confirmButtonText: '知道了',
          type: 'warning'
        });
        return;
      }
      this.addOrUpdateBox.id = this.currentBoxId;
      this.boxList.forEach((res) => {
        if (res.boxId === this.currentBoxId) {
          this.addOrUpdateBox.boxName = res.boxName;
        }
      });
      this.customerConfigure = true;
    },
    // 新增box
    addBox() {
      this.$ajax({
        prompt: true,
        method: 'POST',
        url: '/callServer/box/saveBox',
        data: this.addOrUpdateBox
      }).then(() => {
        this.customerConfigure = false;
        // 添加数据后,刷新页面
        this.getBoxList(true);
      });
    },
    // 更新自定义配置
    modifyCustomerConf() {
      if (this.currentBoxId === null) {
        this.$confirm('未选择任何资源组,不能更新资源组详情配置', '提示', {
          confirmButtonText: '知道了',
          type: 'warning'
        });
        return;
      }
      this.$confirm('您确定要更新资源组详情配置吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const fsDedtailList = [];
        const scDedtailList = [];
        this.message[0].list.forEach((item) => {
          if (item.boxIsValid) {
            fsDedtailList.push(item);
          }
        });
        this.message[1].list.forEach((item) => {
          if (item.boxIsValid) {
            scDedtailList.push(item);
          }
        });
        const reqBody = {
          boxId: this.currentBoxId,
          fsDedtail: fsDedtailList,
          scDedtail: scDedtailList
        };
        this.updateDedtail(reqBody);
      });
    },
    updateDedtail(data) {
      this.$ajax({
        prompt: true,
        method: 'POST',
        url: '/callServer/box/updateDedtail',
        data
      }).then(() => {
        // 更新数据后,刷新页面
        this.getBoxList(false);
      });
    }
  },
  mounted() {
    this.getBoxList(true);
  }
};
</script>



// WEBPACK FOOTER //
// src/page/main/call/serviceBox/index.vue